// Past the component loader's retries and the wc-loader's, so a slow load that
// recovers isn't reported as a failure.
export const HEADER_LOAD_TIMEOUT_MS = 15000;
// Both modals render from the store's state as soon as it changes.
export const SIGN_IN_TIMEOUT_MS = 1000;

/**
 * Reports a header failure to Datadog RUM. RUM runs only on pages whose app
 * starts it, so this is a no-op everywhere else.
 *
 * @param {string} message
 */
export const reportHeaderError = message =>
  window.DD_RUM?.addError?.(new Error(message), { feature: 'header' });

/**
 * A chunk failure is already reported by the wc-loader; this reports the
 * result, a header that never rendered. The hydrated class is added in an
 * animation frame, and those don't run in a hidden tab.
 *
 * @param {HTMLElement} header - the va-header-navigation element
 */
export const reportHeaderNotLoaded = header => {
  if (
    document.visibilityState !== 'hidden' &&
    !header?.classList.contains('hydrated')
  ) {
    reportHeaderError('Header failed to load');
  }
};

export const reportSignInNotOpened = () => {
  if (!document.querySelector('#signin-signup-modal, #form-sign-in-modal')) {
    reportHeaderError('Header sign in opened no modal');
  }
};
